//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PlayerVideo from './players/PlayerVideo.vue';

export default {
  name: 'preview-small-video',
  data() {
    return {
      isMounted: false,
      selectedIndex: 0,
      previewUrl: '',
    };
  },
  props: {
    element: Object,
    showCarousel: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    PlayerVideo,
    PreviewCarousel: () => import('./carousel/PreviewCarousel.vue'),
    PreviewShadow: () => import('@motionelements/product2025/src/components/PreviewShadow.vue'),
  },
  computed: {
    // flickityThumbCarousel() {
    //   if (!this.isMounted) {
    //     return;
    //   }
    //   return this.$refs.flickityThumbs;
    // },
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    getLargePreview(thumbUrl) {
      // example thumbUrl:   https://d31l02nbp0owar.cloudfront.net/m/t/10/49860/a-0005.jpg
      // example previewUrl: https://d25thuhsbcr6yb.cloudfront.net/m/s/10/49860/a-0005.jpg
      const url = thumbUrl.split('/m/t/');
      return `https://d25thuhsbcr6yb.cloudfront.net/m/s/${url[1]}`;
    },
    selectIndex(num) {
      this.selectedIndex = num;
      // this.flickityThumbCarousel.select(this.selectedIndex);
      // this.flickityPreviewCarousel.select(this.selectedIndex);
    },
    // stillClick(index) {
    onClickStill({ url }) {
      console.log(url);
      /*
      // let url = this.element.thumbnails.jpgs[index].url;;
      // https://d31l02nbp0owar.cloudfront.net/m/t/10321/10311848/f-118941-0154.jpg?v=1552546767 needs to become
      // https://d25thuhsbcr6yb.cloudfront.net/m/s/10321/10311848/f-118941-0154.jpg?v=1552546767
      // url = url.replace('/m/t/', '/m/s/');

      const changeUrl = url.split('/m/t/');
      // this.previewUrl = `https://d25thuhsbcr6yb.cloudfront.net/m/s/${url[1]}`;
      // console.log(url);
      // console.log(changeUrl);
      this.previewUrl = `https://d25thuhsbcr6yb.cloudfront.net/m/s/${changeUrl[1]}`;
      // this.$root.$emit('show-modal', 'still-preview', this.previewUrl);
      if (!process.server) {
        window.open(this.previewUrl);
      }

       */
    },
  },
  // watch: {
  //   element: function () {
  //     this.$nextTick(() => {
  //       this.flickityThumbCarousel.rerender();
  //     });
  //   },
  // },
};
